import { graphql, useStaticQuery } from 'gatsby';
import { getSiteConfig } from '../../siteConfig';

/**
 * Custom hook to retrieve a filtered list of pages based on selected page UUIDs.
 * @param {Object} blok - The blok object containing selected page UUIDs.
 * @returns {Array} - The filtered list of pages.
 */

export const usePageMenu = (blok) => {
  const data = useStaticQuery(graphql`
    {
      pages: allStoryblokEntry(sort: { created_at: DESC }) {
        edges {
          node {
            uuid
            name
            full_slug
            internalId
            lang
            translated_slugs {
              lang
              path
              name
            }
          }
        }
      }
    }
  `);

  const language = getSiteConfig().storyblokLanguage;

  const filteredPageResponse = data.pages.edges.filter((edge) => edge);

  let selectedPages = filteredPageResponse.filter((page) =>
    language !== 'default'
      ? blok.selected_pages.includes(page.node.uuid) &&
        page.node.full_slug.startsWith(language + '/')
      : blok.selected_pages.includes(page.node.uuid) &&
        page.node.lang === 'default',
  );

  // Add current language to the selected pages
  selectedPages.forEach((page) => {
    page.node.lang = language;

    if (page.node.content) {
      const content = JSON.parse(page.node.content);
      const hideOnSite = content.hide_on_site || null;

      page.node.hide_on_site = hideOnSite;
      delete page.node.content;
    }
  });

  const indexMap = {};
  blok.selected_pages.forEach((pageUid, index) => {
    indexMap[pageUid] = index;
  });

  // Sort the selected pages based on the order of the selected pages. This prevents the links from being out of order.
  selectedPages.sort((a, b) => indexMap[a.node.uuid] - indexMap[b.node.uuid]);

  // Remove the pages where "hide_on_site" is active.
  selectedPages = selectedPages.filter(
    (page) =>
      !page.node.hide_on_site || !page.node.hide_on_site.includes(language),
  );

  return selectedPages;
};
